import { useLocation, Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center overflow-hidden px-4 py-24 text-center">
      <span className="pointer-events-none absolute -top-6 left-1/2 -translate-x-1/2 select-none font-display-sc text-[220px] leading-none text-background-200">
        404
      </span>
      <div className="relative z-10">
        <span className="inline-flex items-center gap-1.5 rounded bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-700">
          <i className="ri-error-warning-line" aria-hidden="true" />
          页面走丢了
        </span>
        <h1 className="mt-4 font-heading text-3xl font-bold text-foreground-950">这条瓜藤上，没有你要找的内容</h1>
        <p className="mt-3 text-sm text-foreground-500">
          地址 <span className="font-mono text-foreground-700">{location.pathname}</span> 不存在，或相关内容已调整。
        </p>
        <div className="mt-6 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Link to="/" className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition hover:bg-primary-600">
            <i className="ri-home-5-line" aria-hidden="true" />
            返回首页
          </Link>
          <Link to="/list/shenba" className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-200 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-700 transition hover:border-primary-400 hover:text-primary-700">
            <i className="ri-folder-open-line" aria-hidden="true" />
            浏览深扒档案
          </Link>
        </div>
      </div>
    </div>
  );
}